/**
 * Debug tool for CleverTap - run in browser console
 */
export const debugCleverTap = () => {
  console.log('--- CleverTap Debug Tool ---');

  if (!window.clevertap) {
    console.error('❌ CleverTap not found on window object');
    return false;
  }

  // Check initialization
  console.log('✅ CleverTap is available on window');
  console.log('Account ID:', window.clevertap.account?.id);
  console.log('Region:', process.env.REACT_APP_CLEVERTAP_REGION);

  // Check CleverTap ID
  try {
    const ctid = window.clevertap.getCleverTapID();
    console.log('CleverTap ID:', ctid || 'Not available yet');
  } catch (e) {
    console.error('Error getting CleverTap ID:', e);
  }

  // List available methods
  console.log('Available methods:', {
    'event.push': typeof window.clevertap.event?.push === 'function',
    'profile.push': typeof window.clevertap.profile?.push === 'function',
    getCleverTapID: typeof window.clevertap.getCleverTapID === 'function',
  });

  // Send test event
  try {
    window.clevertap.event.push('Debug_Console_Test', {
      Timestamp: Math.floor(Date.now() / 1000),
      TestSource: 'debug_console',
      TestID: Math.random().toString(36).substring(2, 9),
    });
    console.log(
      '✅ Test event sent - check network tab for requests to "wzrkt.com" or "clevertap.com"'
    );
  } catch (e) {
    console.error('❌ Error sending test event:', e);
  }

  // Set test profile
  try {
    window.clevertap.profile.push({
      Site: {
        Identity: 'test_user_' + Date.now(),
        Name: 'Test Console User',
        Email: 'test@example.com',
      },
    });
    console.log('✅ Test profile set - check network tab');
  } catch (e) {
    console.error('❌ Error setting test profile:', e);
  }

  return true;
};

// Auto-run in development/staging
if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'stage') {
  window.debugCleverTap = debugCleverTap;
  console.log('CleverTap debug tool available as window.debugCleverTap()');
}
